<template>
    <div v-if="active == mainKey">
        <slot />
    </div>
</template>

<script>
import { getCurrentInstance, inject } from '@vue/runtime-core';

export default {
    name: 'ItemTab',
    props: ['slug'],
    setup(props) {
        const active = inject('active');
        const mainKey = getCurrentInstance().vnode.key;

        return {
            active,
            mainKey
        }
    }
}
</script>
